
export const sessionStorage = window.sessionStorage
export const localStorage = window.localStorage

